"use client";

import React from "react";
import clsx from "clsx";
import { PiSpinner } from "react-icons/pi";

export type BUTTON_TYPE_SUBMIT = "submit";

type Props = {
    label: string;
    disabled?: boolean;
    pending?: boolean;
    className?: string;
    onClickAction?: React.MouseEventHandler<HTMLButtonElement>;
};

export function SubmitButton({
    label,
    disabled,
    pending,
    className,
    onClickAction,
}: Props) {
    const isDisabled = !!disabled || !!pending;

    return (
        <button
            type="submit"
            onClick={onClickAction}
            disabled={isDisabled}
            aria-disabled={isDisabled}
            aria-busy={!!pending}
            className={clsx(
                "inline-flex items-center justify-center gap-2 md:min-w-52 px-8 py-3 rounded-md",
                "text-center font-jost font-semibold text-lg select-none",
                "bg-black text-white",
                !pending && "hover:bg-black/80",
                pending && "animate-pulse",
                isDisabled ? "opacity-80 cursor-not-allowed" : "opacity-100",
                className
            )}>
            <span className="w-full grow-1 select-none">{label}</span>
            {pending && <PiSpinner className="animate-spin" size="2rem" />}
        </button>
    );
}
